export default __webpack_public_path__ + "static/media/2.669220bb.jpg";